// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorTracker_tabSection__xq6NC {
  padding: 0 24px;
}

.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 {
  display: flex;
  gap: 16px;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorImg__p2ULn {
  flex-shrink: 0;
  width: 141px;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorImg__p2ULn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--border-radius-large);
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP {
  flex: 1 1;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorName__Srv82 {
  padding: 0 0 12px 0;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorName__Srv82 h6 {
  font: var(--body-font-four);
  margin-bottom: 4px;
  color: var(--secondary-Text);
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorName__Srv82 h3 {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 3px;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorLocation__4cf1x {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 0 0 0;
  border-top: 1px solid var(--border);
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorLocation__4cf1x img {
  width: 16px;
  height: 16px;
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorLocation__4cf1x h3 {
  font: var(--body-font-four);
  color: var(--secondary-Text);
}
.VendorTracker_rateModalForm__cWvTV .VendorTracker_label__bSuqt {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  margin-bottom: 5px;
  display: block;
}

.VendorTracker_summary__DE08Q {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--white);
  margin-bottom: 16px;
}
.VendorTracker_summary__DE08Q h4 {
  font: var(--body-font-two);
  font-weight: 600;
  margin-bottom: 16px;
}
.VendorTracker_summary__DE08Q ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
}
.VendorTracker_summary__DE08Q ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  overflow: hidden;
}
.VendorTracker_summary__DE08Q ul li .VendorTracker_heading__7eQLK {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.VendorTracker_summary__DE08Q ul li .VendorTracker_value__xdXy2 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  word-break: break-all;
  max-width: 50%;
  text-align: end;
}
.VendorTracker_summary__DE08Q .VendorTracker_requirements__RFYoI {
  padding-top: 16px;
}
.VendorTracker_summary__DE08Q .VendorTracker_requirements__RFYoI .VendorTracker_heading__7eQLK {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.VendorTracker_summary__DE08Q .VendorTracker_requirements__RFYoI .VendorTracker_value__xdXy2 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}

@media (max-width: 899px) {
  .VendorTracker_tabSection__xq6NC {
    padding: 16px;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 {
    gap: 7px;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorImg__p2ULn {
    width: 100px;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorName__Srv82 {
    padding: 0 0 8px 0;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorName__Srv82 h3 {
    font: var(--body-font-two);
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_vendorDetail__Lm9a2 .VendorTracker_vendorInfo__cmPGP .VendorTracker_vendorLocation__4cf1x {
    flex-wrap: nowrap;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_label__bSuqt {
    font: var(--body-font-three);
    color: var(--secondary-Text);
    margin-bottom: 5px;
    display: block;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_rating__5p0AC {
    list-style: none;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .VendorTracker_rateModalForm__cWvTV .VendorTracker_rating__5p0AC li img {
    width: 23px;
    height: 23px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorTracker/index.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD;;AAGC;EACC,aAAA;EACA,SAAA;AAAF;AAEE;EACC,cAAA;EACA,YAAA;AAAH;AAGG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yCAAA;AADJ;AAKE;EACC,SAAA;AAHH;AAKG;EACC,mBAAA;AAHJ;AAKI;EACC,2BAAA;EACA,kBAAA;EACA,4BAAA;AAHL;AAMI;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAJL;AAQG;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,mCAAA;AANJ;AAQI;EACC,WAAA;EACA,YAAA;AANL;AASI;EACC,2BAAA;EACA,4BAAA;AAPL;AAaC;EACC,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;AAXF;;AAeA;EACC,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAZD;AAcC;EACC,0BAAA;EACA,gBAAA;EACA,mBAAA;AAZF;AAeC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAbF;AAeE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAbH;AAeG;EACC,4BAAA;EACA,0BAAA;AAbJ;AAgBG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AAdJ;AAmBC;EACC,iBAAA;AAjBF;AAmBE;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AAjBH;AAoBE;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAlBH;;AAuBA;EACC;IACC,aAAA;EApBA;EAwBA;IACC,QAAA;EAtBD;EAwBC;IACC,YAAA;EAtBF;EA0BE;IACC,kBAAA;EAxBH;EA0BG;IACC,0BAAA;EAxBJ;EA4BE;IACC,iBAAA;EA1BH;EA+BA;IACC,4BAAA;IACA,4BAAA;IACA,kBAAA;IACA,cAAA;EA7BD;EAgCA;IACC,gBAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;EA9BD;EAiCE;IACC,WAAA;IACA,YAAA;EA/BH;AACF","sourcesContent":[".tabSection {\r\n\tpadding: 0 24px;\r\n}\r\n\r\n.rateModalForm {\r\n\t.vendorDetail {\r\n\t\tdisplay: flex;\r\n\t\tgap: 16px;\r\n\r\n\t\t.vendorImg {\r\n\t\t\tflex-shrink: 0;\r\n\t\t\twidth: 141px;\r\n\r\n\t\t\t// height: 100px;\r\n\t\t\timg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.vendorInfo {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.vendorName {\r\n\t\t\t\tpadding: 0 0 12px 0;\r\n\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t}\r\n\r\n\t\t\t\th3 {\r\n\t\t\t\t\tfont: var(--body-font-one);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tmargin-bottom: 3px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.vendorLocation {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\talign-items: flex-start;\r\n\t\t\t\tgap: 4px;\r\n\t\t\t\tpadding: 12px 0 0 0;\r\n\t\t\t\tborder-top: 1px solid var(--border);\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th3 {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.label {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tmargin-bottom: 5px;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n.summary {\r\n\tpadding: 16px;\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 8px;\r\n\tbackground-color: var(--white);\r\n\tmargin-bottom: 16px;\r\n\r\n\th4 {\r\n\t\tfont: var(--body-font-two);\r\n\t\tfont-weight: 600;\r\n\t\tmargin-bottom: 16px;\r\n\t}\r\n\r\n\tul {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 16px;\r\n\t\tpadding-bottom: 16px;\r\n\r\n\t\tli {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\t.heading {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\r\n\t\t\t.value {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tword-break: break-all;\r\n\t\t\t\tmax-width: 50%;\r\n\t\t\t\ttext-align: end;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.requirements {\r\n\t\tpadding-top: 16px;\r\n\r\n\t\t.heading {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tmargin-bottom: 8px;\r\n\t\t}\r\n\r\n\t\t.value {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 899px) {\r\n\t.tabSection {\r\n\t\tpadding: 16px;\r\n\t}\r\n\r\n\t.rateModalForm {\r\n\t\t.vendorDetail {\r\n\t\t\tgap: 7px;\r\n\r\n\t\t\t.vendorImg {\r\n\t\t\t\twidth: 100px;\r\n\t\t\t}\r\n\r\n\t\t\t.vendorInfo {\r\n\t\t\t\t.vendorName {\r\n\t\t\t\t\tpadding: 0 0 8px 0;\r\n\r\n\t\t\t\t\th3 {\r\n\t\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.vendorLocation {\r\n\t\t\t\t\tflex-wrap: nowrap;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\r\n\t\t.rating {\r\n\t\t\tlist-style: none;\r\n\t\t\tpadding: 0;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 5px;\r\n\r\n\t\t\tli {\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 23px;\r\n\t\t\t\t\theight: 23px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabSection": `VendorTracker_tabSection__xq6NC`,
	"rateModalForm": `VendorTracker_rateModalForm__cWvTV`,
	"vendorDetail": `VendorTracker_vendorDetail__Lm9a2`,
	"vendorImg": `VendorTracker_vendorImg__p2ULn`,
	"vendorInfo": `VendorTracker_vendorInfo__cmPGP`,
	"vendorName": `VendorTracker_vendorName__Srv82`,
	"vendorLocation": `VendorTracker_vendorLocation__4cf1x`,
	"label": `VendorTracker_label__bSuqt`,
	"summary": `VendorTracker_summary__DE08Q`,
	"heading": `VendorTracker_heading__7eQLK`,
	"value": `VendorTracker_value__xdXy2`,
	"requirements": `VendorTracker_requirements__RFYoI`,
	"rating": `VendorTracker_rating__5p0AC`
};
export default ___CSS_LOADER_EXPORT___;
